import React from 'react';

import Layout from 'layouts/Layout';
import Aggrid from './Aggrid';

const AggridLayout = () => <Layout component={Aggrid} hasGrid />;

export default AggridLayout;
